<app-doenkids-image [mediaItem]="{uuid: activity?.media_uuid, description: ''}"></app-doenkids-image>
<div class="flex-col justify-start items-start" style="height: 100%">
  <h1>{{activity?.name}}</h1>
  <p>{{activity?.subtitle}}</p>
  <ng-content></ng-content>
</div>
